export const ROLE_COLORS: Record<string, "purple" | "blue" | "grey"> = {
  owner: "purple",
  admin: "blue",
  member: "grey",
};

export function isAdminOrOwner(roles: { roleName: string }[] | undefined | null): boolean {
  if (!roles) return false;
  return roles.some((r) => r.roleName === "admin" || r.roleName === "owner");
}

export function isSuspended(user: { memberStatus?: string | null | undefined } | null | undefined): boolean {
  return user?.memberStatus === "suspended";
}

export function isInvited(user: { memberStatus?: string | null | undefined } | null | undefined): boolean {
  return user?.memberStatus === "invited";
}

export function getRoleBadge(roles: { roleName: string }[]) {
  const role = roles[0];
  if (!role) return null;
  const name = role.roleName.toLowerCase();
  const color = ROLE_COLORS[name] ?? "grey";
  const label = name.charAt(0).toUpperCase() + name.slice(1);
  return { color, label };
}
